import numeral from "numeral";
import * as d3 from "d3";

/*
 * Belgian number conventions everywhere on the portal: "." between thousands, "," before decimals (1.234,5).
 * Imported once at startup (index.js): numeral and d3 keep their locale globally.
 */

const LOCALE = "fr-be";

if (!numeral.locales[LOCALE]) {
  numeral.register("locale", LOCALE, {
    delimiters: { thousands: ".", decimal: "," },
    abbreviations: { thousand: "k", million: "M", billion: "Md", trillion: "T" },
    ordinal: (n: number) => (n === 1 ? "er" : "e"),
    currency: { symbol: "€" },
  });
}
// format patterns keep their usual syntax ("0,0.[00]"): only the separators in the output change
numeral.locale(LOCALE);

// also used by Observable Plot (same d3 copy) for the ticks of its numeric axes and legends
d3.formatDefaultLocale({ decimal: ",", thousands: ".", grouping: [3], currency: ["", " €"] });
